/* eslint-disable jsx-a11y/anchor-is-valid */
// @flow
import React, { useState, useEffect } from 'react';
// components
import Table from '../../components/Table';
import { useTranslation } from 'react-i18next';
import { Loading } from 'react-loading-ui';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useSelector } from 'react-redux';
import { getTelemetryHistory, getUserRequestAPI } from '../../API/RDPMS_API';
import moment from 'moment';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'material-design-icons/iconfont/material-icons.css';
import '../../../src/assets/scss/custom/components/_alert.scss';
import '../dashboard/Dashboard/Dashboard.css';
import HyperDatepicker from '../../components/Datepicker';
import MultiSelectDropdown from '../../components/MultiSelectDropdown';
import { mapRequestDataToOptions, sizePerPageList, TelemetryHistoryColumns } from './requestDataMapper';

const TelemetryHistory = () => {
    const { auth } = useSelector((state) => ({
        auth: state.Auth,
    }));

    const [selectedDate, setSelectedDate] = useState(new Date());
    const [data, setData] = useState([]);
    const [limit, setLimit] = useState(5);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageCount, setPageCount] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const [isOpen, setIsOpen] = useState(false);

    const [selectedStartDate, setSelectedStartDate] = useState(() => {
        const today = new Date();
        const last7Days = new Date();
        last7Days.setDate(today.getDate() - 7);
        return last7Days;
    });

    const [selectedEndDate, setSelectedEndDate] = useState(new Date());
    const [selectedZones, setSelectedZones] = useState([]);
    const [selectedDivisions, setSelectedDivisions] = useState([]);
    const [selectedStation, setSelectedStation] = useState([]);
    const [selectedAssetsType, setSelectedAssetsType] = useState([]);
    const [selectedAssetsNumber, setSelectedAssetsNumber] = useState([]);

    const [stations, setStations] = useState([]);
    const [zones, setZones] = useState([]);
    const [divisions, setDivisions] = useState([]);
    const [assetsType, setAssetsType] = useState([]);
    const [assetsNumber, setAssetsNumber] = useState([]);

    const [statusMessage, setStatusMessage] = useState('');
    useEffect(() => {
        getTelemetryHistoryData(limit, pageNumber);
        const fetchStation = async () => {
            await getRequestData(auth.user._id);
        };

        fetchStation();
    }, []);

    const { t } = useTranslation();

    const formatDateTime = (date) => {
        if (!date) return {};

        return {
            date: `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(
                2,
                '0'
            )}/${date.getFullYear()}`,
            time: `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(
                date.getSeconds()
            ).padStart(2, '0')}`,
        };
    };

    const getTelemetryHistoryData = async (limits, pages) => {
        Loading();
        let limitNumber = limits ? limits : limit;
        let pagesNumber = pages ? pages : pageNumber;

        const { date: start_date, time: start_time } = formatDateTime(selectedStartDate);
        const { date: end_date, time: end_time } = formatDateTime(selectedEndDate);

        const zone = selectedZones.some((z) => z.value === 'all') ? [] : selectedZones.map((z) => z.value);

        const division = selectedDivisions.some((d) => d.value === 'all') ? [] : selectedDivisions.map((d) => d.value);

        const station = selectedStation.some((s) => s.value === 'all') ? [] : selectedStation.map((s) => s.value);

        const assetsType = selectedAssetsType.some((a) => a.value === 'all')
            ? []
            : selectedAssetsType.map((a) => a.value);

        const assetsNumber = selectedAssetsNumber.some((item) => item.value === 'all')
            ? []
            : selectedAssetsNumber.map((item) => ({
                  sc: item.sc,
                  asset_number_code: item.label,
              }));

        let request = {
            start_date: start_date,
            start_time: start_time,

            end_date: end_date,
            end_time: end_time,

            request: {
                zone: zone,
                division: division,
                station: station,
                asset_type: assetsType,
                asset_number: assetsNumber,
            },
            page_number: pagesNumber,
            page_size: limitNumber,
        };

        // console.log(request, 'request.........');

        let response = await getTelemetryHistory(request);
        // console.log(response, 'response.........');

        if (response) {
            // 🔹 pagination ke liye starting sr no
            let srNo = (pageNumber - 1) * limitNumber + 1;

            // 🔹 final flat table data
            let dataArray = [];

            response?.zone?.forEach((z) => {
                z.division?.forEach((d) => {
                    d.station?.forEach((s) => {
                        s.asset_type?.forEach((at) => {
                            at.asset_number?.forEach((asn) => {
                                // asset_number ke andar dynamic parameters hote hain
                                Object.keys(asn).forEach((paramKey) => {
                                    // asset number key skip
                                    if (paramKey === 'asnc') return;

                                    const paramObj = asn[paramKey];

                                    // safety check
                                    if (!paramObj || !Array.isArray(paramObj.prv) || !Array.isArray(paramObj.prt)) {
                                        return;
                                    }

                                    // actual rows yaha banti hain
                                    paramObj.prv.forEach((value, index) => {
                                        dataArray.push({
                                            srNo: srNo++, // ROW LEVEL COUNT

                                            // header fields
                                            vcc: response?.vcc || '',
                                            vcn: response?.vcn || '',

                                            zoneCode: z.zc || '',
                                            divisionCode: d.dc || '',
                                            stationCode: s.sc || '',

                                            assetType: at.astc || '',
                                            assetNumber: asn.asnc || '',

                                            // parameter details
                                            parameterName: paramKey,
                                            parameterValue: value,
                                            parameterTime: paramObj.prt[index] || '',
                                        });
                                    });
                                });
                            });
                        });
                    });
                });
            });

            console.log(dataArray, 'Telemetry Table Rows');

            setPageNumber(response.currentPage);
            setPageCount(response.totalPages);
            setData(dataArray);
            setTotalCount(response.totalCount);

            setStatusMessage('Alerts telemetry history fetched successfully');
        }
        Loading();
    };

    const getRequestData = async (id) => {
        try {
            Loading(true);

            const response = await getUserRequestAPI(id);

            if (response) {
                const { stations, zones, divisions, assetsType, assetsNumber } = mapRequestDataToOptions(response);

                // Component state me directly set
                setStations(stations);
                setZones(zones);
                setDivisions(divisions);
                setAssetsType(assetsType);
                setAssetsNumber(assetsNumber);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            Loading(false);
        }
    };

    const handlePageChange = async (value) => {
        setPageNumber(1);
        setLimit(value);
        await getTelemetryHistoryData(value, 1);
    };

    const handlePageClick = async (value) => {
        setPageNumber(value);
        await getTelemetryHistoryData(limit, value);
    };

    return (
        <>
            <ToastContainer />

            <div className=" py-3 " style={{ width: '100%' }}>
                <div className="container-fluid px-0">
                    <div className="row align-items-center gx-2 gy-2">
                        {/* Alerts Overview Button */}
                        <div className="col-12 col-md-auto">
                            <button className="btn_1 w-100" style={{ marginLeft: '0' }}>
                                Telemetry History
                            </button>
                        </div>

                        {/* Dropdown and Update Button */}
                        <div className="col-12 col-md-auto ms-md-auto">
                            <div className="d-flex flex-column flex-md-row align-items-stretch align-items-md-center gap-5">
                                {/* Update Button */}
                                <button
                                    className="update d-flex align-items-center justify-content-center flex-grow-1"
                                    id="update">
                                    Update <i className="mdi mdi-autorenew ms-1"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    className="report-alert-card my-4 p-3"
                    style={{
                        width: '100%',
                        boxShadow: ' 0px 0px 35px 0px rgba(154, 161, 171, 0.15)',
                        position: 'relative',
                        height: 'auto',
                    }}>
                    <div className="container form-container justify-content-center">
                        <form>
                            <div className="row d-flex flex-center">
                                {/* Start Date Picker */}
                                <div className="col-md-3 form-group">
                                    <label htmlFor="startDate">Start Date</label>

                                    <div className="custom-datepicker-wrapper">
                                        <HyperDatepicker
                                            hideAddon={true}
                                            type="date"
                                            className="form-control"
                                            dateFormat="yyyy-MM-dd h:mm aa"
                                            value={selectedStartDate}
                                            maxDate={new Date()}
                                            showTimeSelect={true}
                                            timeFormat="h:mm aa"
                                            timeIntervals={15}
                                            onChange={(date) => setSelectedStartDate(date)}
                                        />
                                    </div>
                                    {selectedStartDate && (
                                        <div className="mt-1 text-muted" style={{ fontSize: '13px' }}>
                                            Selected date: {moment(selectedStartDate).format('dddd, MMMM Do, YYYY')}
                                        </div>
                                    )}
                                </div>

                                {/* End Date Picker */}
                                <div className="col-md-3 form-group">
                                    <label htmlFor="endDate">End Date</label>
                                    <div className="custom-datepicker-wrapper">
                                        <HyperDatepicker
                                            hideAddon={true}
                                            type="date"
                                            className="form-control"
                                            defaultValue="2024-08-22"
                                            id="endDate"
                                            dateFormat="yyyy-MM-dd h:mm aa"
                                            value={selectedEndDate}
                                            maxDate={new Date()}
                                            showTimeSelect={true}
                                            timeFormat="h:mm aa"
                                            timeIntervals={15}
                                            onChange={(date) => {
                                                setSelectedEndDate(date);
                                            }}
                                        />
                                    </div>
                                    {selectedEndDate && (
                                        <div className="mt-1 text-muted" style={{ fontSize: '13px' }}>
                                            Selected date: {moment(selectedEndDate).format('dddd, MMMM Do, YYYY')}
                                        </div>
                                    )}
                                </div>

                                <MultiSelectDropdown
                                    label="Zones"
                                    id="zoneSelect"
                                    options={zones}
                                    selectedValues={selectedZones}
                                    onChange={setSelectedZones}
                                />

                                <MultiSelectDropdown
                                    label="Divisions"
                                    id="divisionSelect"
                                    options={divisions}
                                    selectedValues={selectedDivisions}
                                    onChange={setSelectedDivisions}
                                />

                                <MultiSelectDropdown
                                    label="Station"
                                    id="stationSelect"
                                    options={stations}
                                    selectedValues={selectedStation}
                                    onChange={setSelectedStation}
                                />

                                <MultiSelectDropdown
                                    label="Assets Type"
                                    id="assetsSelect"
                                    options={assetsType}
                                    selectedValues={selectedAssetsType}
                                    onChange={setSelectedAssetsType}
                                />

                                <MultiSelectDropdown
                                    label="Assets Number"
                                    id="assetsNumberSelect"
                                    options={assetsNumber}
                                    selectedValues={selectedAssetsNumber}
                                    onChange={setSelectedAssetsNumber}
                                />
                            </div>

                            <div className="row mt-4">
                                <div className="col-md-12 text-end">
                                    <button
                                        type="button"
                                        className="btn "
                                        onClick={() => getTelemetryHistoryData(5, 1)}
                                        style={{
                                            backgroundColor: '#F9B74C',
                                            color: 'black',
                                            fontWeight: 'bold',
                                            width: '150px',
                                            textTransform: 'uppercase',
                                            fontFamily: "'Poppins', sans-serif",
                                            fontSize: '14px',
                                        }}>
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                <div
                    className="col-sm-12 card-alerts my-4 p-3 border-0  text-start no-radius"
                    style={{ width: '100%', position: 'relative' }}>
                    <Table
                        columns={TelemetryHistoryColumns}
                        data={data}
                        pageSize={limit}
                        pageCount={pageCount}
                        pageNumber={pageNumber}
                        totalCount={totalCount}
                        sizePerPageList={sizePerPageList}
                        isSortable={true}
                        pagination={true}
                        isSearchable={true}
                        onPageChange={handlePageChange}
                        onPageClick={handlePageClick}
                    />
                </div>
            </div>

            <div className="modal fade" id="statusModal" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button
                                type="button"
                                className="btn-close ms-auto"
                                data-bs-dismiss="modal"
                                aria-label="Close"></button>
                        </div>
                        <div className="modal-body text-center">
                            <img
                                src="/asset-images/checkmark.png"
                                alt="Success"
                                className="img-fluid"
                                style={{ maxWidth: '100px' }}
                            />
                            <p className="mt-2">{statusMessage}</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default TelemetryHistory;
